import { colors, typography } from '@insurancemenu/imenu-components-lib';
import styled, { css, CSSProp } from 'styled-components';

interface SubscriberCardStyledProps {
  $isAddedToBatchSelection?: boolean;
  $isEditable?: boolean;
}

export const IncompleteProfileErrorTagStyled = styled.div<SubscriberCardStyledProps>`
  ${typography.capsBold[12]}
  color: ${colors.red[600]};
  padding: 1rem;
  border-bottom: 0.1rem solid ${colors.red[600]};
  background-color: ${colors.red[100]};
  position: absolute;

  /* Keep this style order to ensure the tag aligns with the card edge. */
  ${({ $isAddedToBatchSelection }): CSSProp =>
    /* When added to batch selection: border changes from transparent to blue, so tag aligns with card edge. */
    $isAddedToBatchSelection
      ? css`
          top: 0;
          right: 0;
          left: 0;
          border-radius: 0 6px 0 0;
        `
      : css`
          /* When not in batch selection: border is transparent, creating a visual gap between error tag and card
          and needs to be adjusted to align with card edge. Values match SubscriberCardStyled’s border width */
          top: -0.4rem;
          right: -0.4rem;
          left: -1.6rem;
          border-radius: 10px 10px 0 0;
        `}

  /* When not editable: borders width is 0, so tag needs to be adjusted to align with card edge. */
  ${({ $isEditable }): CSSProp =>
    !$isEditable
      ? css`
          top: 0;
          right: 0;
          left: 0;
          border-radius: 6px 6px 0 0;
        `
      : ''}
`;

export const IncompleteProfileInnerTagStyled = styled.div<SubscriberCardStyledProps>`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;

  ${({ $isAddedToBatchSelection }): CSSProp =>
    $isAddedToBatchSelection
      ? css`
          /* Offsets the tag so its position stays consistent when the card is selected */
          margin-left: -1.2rem;
          margin-top: -0.4rem;
        `
      : css`
          margin: 0;
        `}
`;
